<template>
  <div id="app">
    <headers></headers>
    <div class="course-box" v-if="det">
      <div class="w_1400">
        <div class="course-box-title">
          <a href="javascript:history.back(-1)"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
          {{det.name}}
        </div>

        <div class="course-box-content">
          <div class="course-box-content-left" style="">
            <!-- <iframe src="//vpn.file.laodongjiaoyu.vip/uploads/20230311/de2b7163ca4b5ebfcbd0ee08c07080d9.mp4" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe> -->
            <!-- <iframe frameborder="0" :src="url" allowFullScreen="true"
              style="width: 100%;height: 100%;min-height: 740px;"></iframe> -->
              <video controls style="width: 100%;height: 100%;min-height: 740px;">
                  <source :src="url" type="video/mp4">
              </video>
          </div>

          <div class="course-box-content-right">
            <div class="course-detail">
              <p>共<i>{{det.chapter[0].videolong}}分钟</i></p>

              <p><i>{{det.salesnum}}</i>人学过</p>

              <p>售价：<i>￥{{det.price}}</i></p>
            </div>

            <div class="course-list">

              <ul class="ul-div">
                <el-menu default-active="2" class="el-menu-vertical-demo" background-color="rgba(0,0,0,0)"
                  @select="handleSelect">
                  <el-submenu index="1">
                    <template slot="title">
                      <i class="iconfont icon-Frame"></i>
                      <span>目录</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.chapter" :key="item.id" :index="'1-'+key">{{item.title}}
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                </el-menu>
                <!-- <li class="video_delivery"
                  data-src="https://blz-videos.nosdn.127.net/1/OverWatch/AnimatedShots/Overwatch_AnimatedShot_CinematicTrailer.mp4">
                  <p>2.示范课视频</p>
                </li>
                <li class="pdf_delivery" data-src="https://www.jq22.com/demo/jquerypdf201808150005/pdf1.pdf">
                  <p>3.示范课PDF文件</p>
                </li>
                <li class="file_delivery"
                  data-src="http://qudocument.haoxuehaozhi.com/2022/0830/6ee1f26497774841bd254a1be6707802.pptx">
                  <p>4.示范课pptx文件</p>
                  <a href="http://qudocument.haoxuehaozhi.com/2022/0830/6ee1f26497774841bd254a1be6707802.pptx"></a>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import {
    coursedetail
  } from '../../request/api';

  export default {
    name: 'app',
    components: {
      headers,
      footers
    },
    data() {
      return {
        det: '',
        url: ''
      }
    },
    methods: {
      editurl(url) {

      },
      handleSelect(key, keyPath) {
        console.log(this.det.chapter[parseInt(key.slice(2))])
        this.url = this.det.chapter[parseInt(key.slice(2))].videourl
      },
    },
    created() {
      coursedetail({
        course_id: this.$route.query.id
      }).then(res => {
        this.det = res.data
        this.url = this.det.chapter[0].videourl
      })
    }
  }
</script>

<style scoped>
  @import '../../assets/css/home.css';
  .ul-div .el-menu-item.is-active {
    background-color: #22AC38 !important;
    color: #fff !important;
  }

  .dialog-footer {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: inline-block;
  }

  .dialog-footer .el-button {
    width: 48%;
    float: left;
  }

  .dialog-footer .upload-demo {
    width: 48%;
    float: right;
  }

  .dialog-footer .upload-demo .el-upload {
    width: 100%;
  }

  .dialog-footer .upload-demo .el-button {
    width: 100%;
    height: 40px;
    background: #22AC38;
    border: #22AC38;
  }

  .el-dialog {
    width: 460px;
    border-radius: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/courseshow.vue